import { useCallback, useEffect, useRef, useState } from 'react';
import { WorkoutsService } from '../../workouts/workoutsService';

/**
 * Los días de esta semana en los que ya se ha entrenado.
 *
 * Se rellena solo según se entrena y se vacía al empezar la semana siguiente,
 * porque la ventana la calcula el backend y se corre sola: no hay ninguna
 * bandera que alguien tenga que reiniciar el domingo por la noche.
 *
 * Si la petición falla no se enseña ningún error: es un adorno de la tira de
 * la semana, no la rutina. Que no salgan las marcas es mucho menos grave que
 * una franja roja por algo que nadie ha pedido.
 */
export function useMiSemana() {
  const [entrenados, setEntrenados] = useState<ReadonlySet<number>>(
    () => new Set(),
  );
  const vivo = useRef(true);

  useEffect(() => {
    vivo.current = true;
    WorkoutsService.miSemana()
      .then((semana) => {
        if (!vivo.current) return;
        const dias = new Set<number>();
        for (const sesion of semana.sesiones) {
          dias.add(new Date(sesion.startedAt).getDay());
        }
        setEntrenados(dias);
      })
      .catch(() => {
        // Sin marcas y a otra cosa.
      });
    return () => {
      vivo.current = false;
    };
  }, []);

  /** Marca un día sin volver a preguntar: acabas de empezar ese entreno. */
  const marcarEntrenado = useCallback((dia: number) => {
    setEntrenados((prev) => {
      if (prev.has(dia)) return prev;
      const siguiente = new Set(prev);
      siguiente.add(dia);
      return siguiente;
    });
  }, []);

  return { entrenados, marcarEntrenado };
}
